import { PrimaryGeneratedColumn, Column, ManyToOne, JoinColumn, Entity, Index, OneToMany } from 'typeorm'

import RespondentSession from './RespondentSession'
import Response from './Response'
import Survey from './survey/Survey'
import RespondentSurveyEvent from './RespondentSurveyEvent'
import Audience from './survey/Audience'

export function createRrdbRespondentSurveyJoinId (rrdbSessionId: string, qtestSurveyTapId: string) {
  return `${rrdbSessionId}_${qtestSurveyTapId}`
}

@Entity('respondent_surveys')
@Index(['respondentSession', 'survey'], { unique: true })
export default class RespondentSurvey {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ name: 'client_id' })
  clientId?: string

  @Column({ name: 'created_at' })
  createdAt!: Date

  @ManyToOne(type => RespondentSession, respondentSession => respondentSession.respondentSurveys)
  @JoinColumn({ name: 'respondent_session_id' })
  respondentSession?: RespondentSession

  @ManyToOne(type => Survey, s => s.respondentSurveys)
  @JoinColumn({ name: 'survey_id' })
  survey?: Survey

  @Column({ name: 'survey_id' })
  surveyId!: string

  @OneToMany(type => Response, r => r.respondentSurvey)
  responses?: Response[]

  @OneToMany(type => RespondentSurveyEvent, r => r.respondentSurvey)
  respondentSurveyEvents?: RespondentSurveyEvent[]

  @ManyToOne(type => Audience, a => a.respondentSurveys)
  @JoinColumn({ name: 'audience_id' })
  audience?: Audience

  // This property allows channel to link this RespondentSurvey with its Responses
  // during upsert.
  @Column({ name: 'rrdb_respondent_survey_join_id' })
  @Index({ unique: true })
  rrdbRespondentSurveyJoinId!: string

  // This property allows channel to link this RespondentSurvey with the associated
  // channel DB Survey or Audience during upsert. This property itself is not persisted
  // to channel DB.
  qtestTapId!: string

  // This property allows channel to link this RespondentSurvey with the associated
  // channel DB RespondentSession during upsert. This property itself is not persisted
  // to channel DB.
  rrdbSessionId!: string

  // This property allows channel to link this RespondentSurvey with the
  // associated channel DB Audience during upsert. This property itself is
  // not persisted to channel DB.
  rrdbSegmentId!: string

  // This property allows channel to determine the type of Survey this RespondentSurvey
  // is attached to. This property itself is not persisted to channel DB.
  isSurveyTypeScreener!: boolean
}
